import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { constants } from 'src/app/shared/constants';
import { NgbModal,ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

import { SupportCaseSearchCriteria } from 'src/app/shared/model/searchCriteria';
import { ErrorService } from 'src/app/shared/services/error.service';
import { ItsmService } from 'src/app/shared/services/itsm.service';
import { UserPreferenceService } from 'src/app/shared/services/userpreferences.service';
import { Asset, Case, Contact } from 'src/app/shared/model/itsm';
import { ActivatedRoute } from '@angular/router';
import { Utilities } from 'src/app/shared/utilities';
import { OktaAuthService } from 'src/app/app.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
@Component({
  selector: 'app-supportdashboard',
  templateUrl: './supportdashboard.component.html',
  styleUrls: ['./supportdashboard.component.scss']
})
export class SupportDashboardComponent implements OnInit {

  requestTracker:number = 0;
  // pagination
  perPage = constants.recordsPerPage.cases;
  currentPage: number;

  // data
  cases: Case[];
  casesCount: number;
  searchCriteria: SupportCaseSearchCriteria;
  searched: boolean;
  casesLoaded: boolean;

  // counts
  casesCreatedSinceLastLogin: number;
  casesUpdatedSinceLastLogin: number

  // dropdown cache
  caseTypeCV: string[];
  caseCategoryCV: string[];
  casePriorityCV: string[];
  caseAssetCV: Asset[];
  caseStatusCV: string[];
  contacts: Contact[];
  contactsCreatedBy: Contact[];

  // saved searches
  savedSearches: SupportCaseSearchCriteria[];
  searchName: string;
  hideSaveSearch: boolean;

  // user prefs
  flags: any[];
  flagRefs: string[];
  flaggingRef: string //used to stop the flapping of flags whilst waiting for update to complete

  // view
  viewType: string;
  page: string;

  // search
  advSearch = false;

  // search fields
  caseNumber: string; 
  description: string;    
  createdFrom: string;
  createdTo: string;
  updatedFrom: string;
  updatedTo: string;
  closedDateFrom: string;
  closedDateTo: string;
  asset: string;
  assetId: string;
  type: string[];
  category: string;
  priority: string[];
  subject: string;
  status: string;
  contact: string;
  contactEmail: any[];
  createdByEmail: [];
  createdPeriod: string;
  escalation: string;
  trueFalsePositives: string;

  sort: string;
  sortBy: string;

  datepipe: DatePipe = new DatePipe('en-GB')

  // initial page to load
  loadpage: string;
  allowedCaseTypes: string[];

  //Generating PDF
  fileUploaded = false;

  //Modal
  closeResult: string;
  PDFName: string="";
  reportOption: string = "pdf";
  pdfAccessLevel : string = "0";

  //dropdowns
  dropdownList = [];
  selectedItems = [];
  dropdownSettings: IDropdownSettings = {
    singleSelection: false, 
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: false};

  dropdownSettingsContact: IDropdownSettings = {
    singleSelection: false, 
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    idField: 'email',
    textField: 'fullName',
    allowSearchFilter: false};

  dropdownSettingsCreatedBy: IDropdownSettings = {
    singleSelection: false, 
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    idField: 'email',
    textField: 'fullName',
    allowSearchFilter: false};
    
  dropdownSettingsColumns: IDropdownSettings = { 
    singleSelection: false, 
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    idField: 'field',
    textField: 'name',
    allowSearchFilter: false};
  
  //dropdown columns
  selectedColumns = [ 
    {"name":"Case Number", "field": "caseNumber"},
    {"name":"Subject", "field": "subject"},
    {"name":"Priority", "field": "priority"},
    {"name":"Status", "field": "status"},
    {"name":"Type", "field": "type"},
    {"name":"Created Date", "field": "createdDate"},
    {"name":"Updated", "field": "lastModifiedDate"},
    {"name":"Contact", "field": "contact"}
  ];
  columnsSelection =  [
    {"name":"Case Number", "field": "caseNumber"},
    {"name":"Subject", "field": "subject"},
    {"name":"Priority", "field": "priority"},
    {"name":"Status", "field": "status"},
    {"name":"Type", "field": "type"},
    {"name":"Created Date", "field": "createdDate"},
    {"name":"Updated", "field": "lastModifiedDate"},
    {"name":"Escalation", "field": "escalation"},
    {"name":"Service Contract", "field": "serviceContract"},
    {"name":"Opened By", "field": "openedBy"},
    {"name":"Updated By", "field": "updatedBy"},
    {"name":"Made SLA", "field": "madeSLA"}
  ];


  constructor(  private itsmService: ItsmService,
                private modalService: NgbModal,
                private errorService: ErrorService,
                private userprefService: UserPreferenceService,
                private route: ActivatedRoute,
                private auth: OktaAuthService) { }

  
  ngOnInit() {
    
    this.route.params.subscribe(params => this.loadpage = params['loadpage']);

    // initialise
    this.hideSaveSearch = false;
    this.currentPage = 1;
    this.searched = false;
    this.searchCriteria = new SupportCaseSearchCriteria();
    this.casesLoaded = false;

    //Hard coded case types to not have to pull all types
    this.caseTypeCV = ["Change Request", "Incident", "Service Request"];

    this.auth.getUserDetails().then(val => {
      this.allowedCaseTypes = [];
      val.groups.map(g => {
        if(g.includes('Access_')){
          this.allowedCaseTypes.push(g.substr(g.indexOf('Access_')+7));
        }
      });

      // filter case type by roles
      this.caseTypeCV = this.caseTypeCV.filter(t => 
        (t === 'Change Request' && this.allowedCaseTypes.includes("Change_Request")) ||
        (t === 'Service Request' && this.allowedCaseTypes.includes("Service_Request")) ||
        (t === 'Incident' && this.allowedCaseTypes.includes("Incident"))
      );
    });

    // count the signals since last login
    this.userprefService.getUserLastLoginDate()
      .then(res => {
        // get new and updated
        this.itsmService.cacheCasesCountCreatedSinceLastLogin(res)
          .then(res => {
            this.casesCreatedSinceLastLogin = res;
          })
          .catch(err => {
            throw err;
          })

        this.itsmService.cacheCasesCountUpdatedSinceLastLogin(res)
          .then(res => {
            this.casesUpdatedSinceLastLogin = res;
          })
          .catch(err => {
            throw err;
          })
      })
      .catch(err => {
        this.handlerError(err);
      });

    // load the flags signals from the user preferences
    this.refreshSupportUserPrefs();

    // load cache for dropdowns
    this.loadCache();

    this.page = 'cases';
    // load default page for navigation
    if(!this.loadpage || this.loadpage === 'latest'){
      // load the latest signals and stats for this month
      this.latestCases()
    }else if(this.loadpage === 'lastlogincreated'){
      // other options for click through from dashboard
      this.loadNewSinceLastVisit();
    }else if(this.loadpage === 'opencases'){
      this.loadOpenCases();
    }else if(this.loadpage === 'lastloginupdated'){
      this.loadUpdatedSinceLastVisit();
    }else if(this.loadpage === 'created30days'){
      this.loadCreatedInDays(30);
    }else if(this.loadpage === 'updated30days'){
      this.loadUpdatedInDays(30);
    }else if(this.loadpage === 'newhigh30days'){
      this.loadNewHighInDays(30);
    }else if(this.loadpage === 'newcritical30days'){
      this.loadNewHighInDays(30);
    }else if(this.loadpage === 'customerpending'){
      this.loadCustomerPending();
    }
    else if (this.loadpage == '1' || this.loadpage == '2' || this.loadpage == '3' || this.loadpage == '4'){
      this.priorityCases(this.loadpage)
    }
    else if (this.loadpage == "TPO" || this.loadpage == "FPO"){
      this.loadTrueFalsePositives(this.loadpage)
    }
  }


  public editColumns(content){
    this.openColumnModal(content)
  }
  public openModal(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;

      if(result == 'save'){
       //debugger
       this.search(true)

      }

    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  public openColumnModal(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;

      if(result == 'save'){
       

      }

    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }

  /**
   * Cache the CV values for the dropdowns
   */
  loadCache(){
    Promise.all([
      Promise.resolve(), // was this.itsmService.getCachedCV('Case','Type'),
      this.itsmService.getCachedCV('Case','Priority'),
      this.itsmService.getCachedAssets(),
      this.itsmService.getCachedCV('Case','Status'),
      this.itsmService.getCachedContacts(),
    ])
    .then(res => {
      this.casePriorityCV = res[1];
      this.caseAssetCV = res[2];
      this.caseStatusCV = res[3];
      this.contactsCreatedBy = res[4];
      this.contacts = [{id:'1',accountId:'2', email: "unassigned", fullName: "Unassigned"}, ...res[4]];
    })
    .then(() => {
      this.casePriorityCV = this.casePriorityCV.filter(p => p.startsWith("1 -") || p.startsWith("2 -") || p.startsWith("3 -") || p.startsWith("4 -") || p.startsWith("5 -"));
    })
    .then(() => {
      this.caseTypeCV = this.caseTypeCV.filter(p => p.startsWith("Change") || p.startsWith("Service") || p.startsWith("Incident"));
      this.caseTypeCV.sort(
        function(a, b){
          if(a < b) { return -1; }
          if(a > b) { return 1; }
          return 0;
        });
    })
    .catch(err => {
      this.errorService.handlerError(err);
    });
  }

  /**
   * Refresh the local flagRefs and viewType variable from user preferences
   */
  refreshSupportUserPrefs(): Promise<void>{
    // load the flagged signals from user preferences
    return new Promise((resolve,reject) => {
      this.userprefService.getUserPreferences()
        .then(res => {
          if(res.flags && res.flags.support){
            this.flagRefs = res.flags.support;
          }else{
            this.flagRefs = [];
          }
          if(res.supportViewType){
            this.viewType = res.supportViewType;
          }else{
            this.viewType = 'list';
          }
          if(res.searches && res.searches.support){
            this.savedSearches = res.searches.support;
          }else{
            this.savedSearches = [];
          }

          resolve();
        })
        .catch(err => reject(err));
    });
  }


  /**
   * Search itsm on a bunch of attributes
   */
  search(exportData: boolean = false) { 
    this.page = 'cases';
    this.casesLoaded = false;
    this.casesCount = null;
    this.searched = true;
    this.searchCriteria = new SupportCaseSearchCriteria();
    this.searchCriteria.limit = this.perPage;

    if(this.caseNumber){
      this.searchCriteria.caseNumber = this.caseNumber;
    }
    if(this.description){
      this.searchCriteria.description = this.description;
    }

    if(this.createdPeriod){
      if(this.createdPeriod === '1w'){
        this.searchCriteria.createdFrom = Utilities.getTodayMinusDays(7);
        this.searchCriteria.createdTo = Utilities.getToday();
      }else if(this.createdPeriod === '2w'){
        this.searchCriteria.createdFrom = Utilities.getTodayMinusDays(14);
        this.searchCriteria.createdTo = Utilities.getToday();
      }else if(this.createdPeriod === 'thismonth'){
        this.searchCriteria.createdFrom = Utilities.getFirstOfCurrentMonth();
        this.searchCriteria.createdTo = Utilities.getLastOfCurrentMonth();
      }else if(this.createdPeriod === 'lastmonth'){
        this.searchCriteria.createdFrom = Utilities.getFirstOfLastMonth();
        this.searchCriteria.createdTo = Utilities.getLastOfLastMonth();
      }

    }else{
      if(this.createdFrom){
        this.searchCriteria.createdFrom = this.createdFrom;
      }
      if(this.createdTo){
        this.searchCriteria.createdTo = this.createdTo;
      }
    }

    if(this.updatedFrom){
      this.searchCriteria.updatedFrom = this.updatedFrom;
    }
    if(this.updatedTo){
      this.searchCriteria.updatedTo = this.updatedTo;
    }
    if(this.closedDateFrom){
      this.searchCriteria.closedDateFrom = this.closedDateFrom;
    }
    if(this.closedDateTo){
      this.searchCriteria.closedDateTo = this.closedDateTo;
    }
    if(this.assetId){
      this.searchCriteria.assetId = this.assetId;
    }
    if(this.asset){
      this.searchCriteria.asset = this.asset;
    }
    if(this.type){
      this.searchCriteria.type = this.type.toString();
    }
    if(this.category){
      this.searchCriteria.category = this.category;
    }
    if(this.priority){
      this.searchCriteria.priority = this.priority.map(a => a).join(",");
    }
    if(this.subject){
      this.searchCriteria.subject = this.subject;
    }
    if(this.status){
      this.searchCriteria.status = this.status;
    }
    if(this.contact){
      this.searchCriteria.contact = this.contact;
    }
    if(this.contactEmail?.length > 0){
      if(this.contactEmail.length == 1 && this.contactEmail[0].email == "unassigned"){
        this.searchCriteria.contactEmailUnassigned = 'unassigned'
      }
      else{
      this.searchCriteria.contactEmail = this.contactEmail.map(function(el: {email,fullName}){return el.email}).toString()
      }
    }
    if(this.createdByEmail?.length > 0){
      this.searchCriteria.createdByEmail = this.createdByEmail.map(function(el: {email,fullName}){return el.email}).toString()
    }
    if(this.sort) {
      this.searchCriteria.sort = this.sort;
    }
    if(this.sortBy) { 
      this.searchCriteria.sortBy = this.sortBy;
    }
    if(this.escalation) {
      this.searchCriteria.escalation = this.escalation;
    }
    if(this.trueFalsePositives){
      this.searchCriteria.escalation = "To Customer"
      this.searchCriteria.securityAnalyt = true;
      this.searchCriteria.limit = undefined;
    }


    if(exportData){
         // fetch the actual records 
         this.searchCriteria.count = false;
         this.searchCriteria.limit = undefined;
         this.searchCriteria.export = true;
         this.searchCriteria.pdfName = this.PDFName +  ' - ' + constants.accessLevels[this.pdfAccessLevel] +  "." + this.reportOption;
         this.searchCriteria.pdfAccessLevel = this.pdfAccessLevel;
        
         this.itsmService.caseSearch(this.searchCriteria)
           .then(res => {
             this.casesLoaded = true 
             this.fileUploaded = true
           })
           .catch(err => {
            console.log(err)
           });
     
    }
    else{

      this.caseSearch()
      .then(result => {
        if (!result.abandoned) {
          this.casesLoaded = true 
        }
      })
    }

  }

  /**
   * Reset search fields
   * @param view 
   */
  reset(){
    delete this.caseNumber;
    delete this.description;
    delete this.createdFrom;
    delete this.createdTo;
    delete this.updatedFrom;
    delete this.updatedTo;
    delete this.closedDateFrom;
    delete this.closedDateTo;
    delete this.createdPeriod;
    delete this.assetId;
    delete this.type;
    delete this.category;
    delete this.priority;
    delete this.subject;
    delete this.sort;
    delete this.status;
    delete this.sortBy;
    delete this.contact;
    delete this.contactEmail;
    delete this.createdByEmail;
    delete this.asset;
    delete this.escalation;
    this.searched = false;
  }

  /**
   * Add a case reference to the user's preferences so they can flag cases
   * @param caseRef 
   */
  flag(caseRef: string) {
    // note which ref is being processed so we can stop user double clicking
    this.flaggingRef = caseRef;

    // update the users flags appropriately
    this.userprefService.userPreferencesUpdateFlags(constants.local.flags.support, caseRef, this.flagRefs.includes(caseRef))
      .then(res => {
        this.refreshSupportUserPrefs()
          .then(res => {
            this.flaggingRef = undefined;
          })
          .catch(err => { throw err });
      })
      .catch(err => {
        this.handlerError(err);
      })
  }

  /**
   * Toggle between grid/list view
   * @param view 
   */
  changeViewType(view: string){
    // set local variable to determine what view the user is using
    this.viewType = view;

    // update the users flags appropriately
    this.userprefService.userPreferencesUpdateSingle(constants.local.views.support, view)
      .then(res => {
        this.refreshSupportUserPrefs()
          .catch(err => { throw err });
      })
      .catch(err => {
        this.handlerError(err);
      })

  }

  /**
   * Return the top 12 cases
   */
  latestCases() {
    this.casesLoaded = false;
    this.searched = false;

    this.searchCriteria = new SupportCaseSearchCriteria();
    this.searchCriteria.limit = 12;
    this.searchCriteria.skip = this.perPage * (this.currentPage-1);

    if(this.sort && this.sortBy){
      this.searchCriteria.sort = this.sort;
      this.searchCriteria.sortBy = this.sortBy;
    }

    this.caseSearch()
      .then(result => {
        if (!result.abandoned) {
          this.casesLoaded = true
        }
      })
      .catch(err => {
        this.handlerError(err);
      });
  }

  /**
   * Pagination
   * @param event 
   */
  onPageChange(event): void {
    this.searchCriteria.skip = this.perPage * (this.currentPage-1);
    this.casesLoaded = false;
    this.caseSearch()
      .then(result => {
        if (!result.abandoned) {
          this.casesLoaded = true
        }
      })
  }

  contactFilterChange(event){
    if (event.email == "unassigned"){
      this.contactEmail = [{ email: "unassigned", fullName: "Unassigned"}]
    }
    else if (this.contactEmail.findIndex(x => x.email == 'unassigned') != -1){
     this.contactEmail = [event]
    }
  }


  /** 
   * Utility method to load count of results as well as results themselves
   * Used for pagination
   */
  private caseSearch(): Promise<any> {
    return new Promise((resolve,reject) => {
      this.searchCriteria.count = true;
      let tempLimit = this.searchCriteria.limit;
      this.searchCriteria.limit = undefined;
      
      this.searchCriteria.requestTracker.requestTracker = true;
      this.requestTracker = this.requestTracker + 1;
      this.searchCriteria.requestTracker.count = this.requestTracker;

      // fetch the count of matching records (happens before the actual results are fetched)
      this.itsmService.caseSearch(this.searchCriteria)
        .then(res => {
          // if the count is not from the latest search, don't perform the full search
          if(res.requestTracker == this.requestTracker.toString()) {
            res = res.data
            if(res && res){
              this.casesCount = res;
            }else{
              this.casesCount = 0;
            }

            // fetch the actual records 
            this.searchCriteria.count = false;
            this.searchCriteria.limit = tempLimit;
            
            this.itsmService.caseSearch(this.searchCriteria)
              .then(res => {
                // if the results are not from the latest search, don't show them
                if(res.requestTracker == this.requestTracker.toString()){
                  res = res.data
                  // avoid a race condition when user changes tabs
                  if (this.page !== 'flagged') {
                    this.cases = convertDatesFormat(res);
                     
                    //checking true/false positives
                    if (this.trueFalsePositives){
                      let trueFalseCases = []
                      this.cases.forEach((c => {
                        if(Utilities.checkTruePositive(c.caseNumber, c.status, c.closureCode)){
                          if(this.trueFalsePositives == "1"){
                            trueFalseCases.push(c)
                          }
                        }
                        else if (Utilities.checkFalsePositive(c.status, c.closureCode)){
                          if(this.trueFalsePositives == "2"){
                            trueFalseCases.push(c)
                          }
                        }
                      }))
                      
                      this.cases = trueFalseCases
                      this.casesCount = this.cases.length;
                    }
                    
                  }
                  resolve({abandoned: false});
                }
                else{
                  resolve({abandoned: true})
                }
              })
              .catch(err => {
                throw err;
              });
          } else {
            resolve({abandoned: true});
          }
        })
        .catch(err => {
          reject();
          this.handlerError(err);
        });
    });
  }

  /**
   * Load whatever we need for analytics
   * TODO will need caching
   */
  loadAnalytics(){
  }

  /** 
   * Load flagged cases
   */
  loadFlagged(){
    this.page = 'flagged';
    this.searched = false;
    this.casesLoaded = false;

    if(this.flagRefs.length === 0){
      // avoid a race condition when user changes tabs
      if (this.page === 'flagged') {
        this.cases = [];
        this.casesLoaded = true;
        this.casesCount = 0;
      }
    }else{
      let loadListCriteria = new SupportCaseSearchCriteria();
      loadListCriteria.limit = 12;
      loadListCriteria.caseRefs = this.flagRefs;
  
      this.itsmService.caseLoadList(loadListCriteria)
        .then(res => {
          // avoid a race condition when user changes tabs
          if (this.page === 'flagged') {
            this.cases = convertDatesFormat(res);
            this.casesLoaded = true;
            this.casesCount = this.cases.length;
          }
        })
        .catch(err => {
          this.handlerError(err);
        })
    }
    
  }

  /**
   * Load cases updated in a number of days
   */
  loadUpdatedInDays(days: number) {
    this.page = 'cases';
    this.casesLoaded = false;

    this.searchCriteria = new SupportCaseSearchCriteria();
    this.searchCriteria.closedDateFrom = Utilities.getTodayMinusDays(days);
    this.searchCriteria.closedDateTo = Utilities.getToday();
    this.searchCriteria.count = true;
    if(this.sort && this.sortBy){
      this.searchCriteria.sort = this.sort;
      this.searchCriteria.sortBy = this.sortBy;
    }
    this.caseSearch()
      .then(result => {
        if (!result.abandoned) {
          this.casesLoaded = true
        }
      })
      .catch(err => {
        throw err;
      })
  }

  exportReport(content){
    this.openModal(content)
  }
  
  /**
   * Load cases created in a number of days
   */
  loadCreatedInDays(days: number) {
    this.page = 'cases';
    this.casesLoaded = false;

    this.searchCriteria = new SupportCaseSearchCriteria();
    this.searchCriteria.createdFrom = Utilities.getTodayMinusDays(days);
    this.searchCriteria.createdTo = Utilities.getToday();
    this.searchCriteria.count = true;
    if(this.sort && this.sortBy){
      this.searchCriteria.sort = this.sort;
      this.searchCriteria.sortBy = this.sortBy;
    }
    this.caseSearch()
      .then(result => {
        if (!result.abandoned) {
          this.casesLoaded = true
        }
      })
      .catch(err => {
        throw err;
      })
  }

  /**
     * Load open cases that are high priority and new in a number of days
     */
  loadOpenCases() {
    this.page = 'cases';
    this.casesLoaded = false;

    this.searchCriteria = new SupportCaseSearchCriteria();
    this.searchCriteria.status = constants.itsm.open;
    if(this.sort && this.sortBy){
      this.searchCriteria.sort = this.sort;
      this.searchCriteria.sortBy = this.sortBy;
    }
    this.caseSearch()
      .then(result => {
        if (!result.abandoned) {
          this.casesLoaded = true
        }
      })
      .catch(err => {
        throw err;
      });
  }

  /**
   * Load cases that are pending customer
   */
  loadCustomerPending() {
    this.page = 'cases';
    this.casesLoaded = false;

    this.searchCriteria = new SupportCaseSearchCriteria();
    this.searchCriteria.status = constants.itsm.pendingCustomer;
    if(this.sort && this.sortBy){
      this.searchCriteria.sort = this.sort;
      this.searchCriteria.sortBy = this.sortBy;
    }
    this.caseSearch()
      .then(result => {
        if (!result.abandoned) {
          this.casesLoaded = true
        }
      })
      .catch(err => {
        throw err;
      });
  }

  /**
   * Load cases that are high priority and new in a number of days
   */
  loadNewHighInDays(days: number) {
    this.page = 'cases';
    this.casesLoaded = false;


    this.searchCriteria = new SupportCaseSearchCriteria();
    this.searchCriteria.createdFrom = Utilities.getTodayMinusDays(days);
    this.searchCriteria.createdTo = Utilities.getToday();
    this.searchCriteria.status = constants.itsm.open;
    this.searchCriteria.priority = constants.itsm.high;
    this.searchCriteria.count = true;
    if(this.sort && this.sortBy){
      this.searchCriteria.sort = this.sort;
      this.searchCriteria.sortBy = this.sortBy;
    }
    this.caseSearch()
      .then(result => {
        if (!result.abandoned) {
          this.casesLoaded = true
        }
      })
      .catch(err => {
        throw err;
      });
  }

  /**
   * Load cases that are high priority and new in a number of days
   */
   loadNewCriticalInDays(days: number) {
    this.page = 'cases';
    this.casesLoaded = false;


    this.searchCriteria = new SupportCaseSearchCriteria();
    this.searchCriteria.createdFrom = Utilities.getTodayMinusDays(days);
    this.searchCriteria.createdTo = Utilities.getToday();
    this.searchCriteria.status = constants.itsm.open;
    this.searchCriteria.priority = constants.itsm.critical;
    this.searchCriteria.count = true;
    if(this.sort && this.sortBy){
      this.searchCriteria.sort = this.sort;
      this.searchCriteria.sortBy = this.sortBy;
    }
    this.caseSearch()
      .then(result => {
        if (!result.abandoned) {
          this.casesLoaded = true
        }
      })
      .catch(err => {
        throw err;
      });
  }

  /**
   * Load cases updated since last login
   */
  loadUpdatedSinceLastVisit() {
    this.page = 'cases';
    this.casesLoaded = false;

    // since last login
    this.userprefService.getUserLastLoginDate()
      .then(res => {
        this.searchCriteria = new SupportCaseSearchCriteria();
        this.searchCriteria.updatedFrom = this.datepipe.transform(res, "yyyy-MM-dd");
        this.searchCriteria.updatedTo = Utilities.getToday();
        if(this.sort && this.sortBy){
          this.searchCriteria.sort = this.sort;
          this.searchCriteria.sortBy = this.sortBy;
        }
        this.caseSearch()
          .then(result => {
            if (!result.abandoned) {
              this.casesLoaded = true
            }
          })
          .catch(err => {
            throw err;
          })
      })
      .catch(err => {
        this.handlerError(err);
      })
  }

  /**
   * Load cases created since last login
   */
  loadNewSinceLastVisit() {
    this.page = 'cases';
    this.casesLoaded = false;

     // since last login
     this.userprefService.getUserLastLoginDate()
      .then(res => {
        this.searchCriteria = new SupportCaseSearchCriteria();
        this.searchCriteria.createdFrom = this.datepipe.transform(res, "yyyy-MM-dd");
        this.searchCriteria.createdTo = Utilities.getToday();
        if(this.sort && this.sortBy){
          this.searchCriteria.sort = this.sort;
          this.searchCriteria.sortBy = this.sortBy;
        }
        this.caseSearch()
          .then(result => {
            if (!result.abandoned) {
              this.casesLoaded = true
            }
          })
          .catch(err => {
            throw err;
          })
      })
      .catch(err => {
        this.handlerError(err);
      })
  }

  /**
   * Open modal
   * @param content 
   */
  openSearchModal(content) {
    this.modalService.open(content, { ariaLabelledBy: 'search-modal' }).result
      .then((result) => {
        if(result == 'save'){
          this.saveSearch();
        }
      }, (reason) => {
      });
  }

  /**
   * Save the search criteria in user preferences for future use
   */
  saveSearch() : void {
    let copy = (JSON.parse(JSON.stringify(this.searchCriteria)));
    delete copy.count;
    delete copy.limit;
    delete copy.skip;
    delete copy.sort;
    delete copy.sortOrder;
    copy.name = this.searchName;

    this.userprefService.userPreferencesUpdateChildArray("searches", "support", copy, false)
      .then(res => {
        this.searchName = undefined;
        this.refreshSupportUserPrefs();
        this.hideSaveSearch = true;
      });

  }

  
  sortResults(field: string){
    this.currentPage = 1;
    if(this.sort === field && this.sortBy){
      if(this.sortBy === 'DESC') {
        this.sortBy = 'ASC';
      }else{
        this.sortBy = 'DESC';
      }
    }else{
      this.sort = field;
      this.sortBy = 'DESC';
    }

    if(this.searched){
      this.search();
    }else{
      if(!this.loadpage || this.loadpage === 'latest'){
        // load the latest signals and stats for this month
        this.latestCases()
      }else if(this.loadpage === 'lastlogincreated'){
        // other options for click through from dashboard
        this.loadNewSinceLastVisit();
      }else if(this.loadpage === 'lastloginupdated'){
        // other options for click through from dashboard
        this.loadUpdatedSinceLastVisit();
      }else if(this.loadpage === 'created30days'){
        // other options for click through from dashboard
        this.loadCreatedInDays(30);
      }else if(this.loadpage === 'updated30days'){
        // other options for click through from dashboard
        this.loadUpdatedInDays(30);
      }else if(this.loadpage === 'newhigh30days'){
        // other options for click through from dashboard
        this.loadNewHighInDays(30);
      }
     
    }
  }

  /**
   * Return cases based on true/false positives
   */
   loadTrueFalsePositives(positive) {
    this.casesLoaded = false;
    this.searched = false;

    this.searchCriteria = new SupportCaseSearchCriteria();

    this.searchCriteria.securityAnaltyics = true;
    
    if(this.sort && this.sortBy){
      this.searchCriteria.sort = this.sort;
      this.searchCriteria.sortBy = this.sortBy;
    }

    this.caseSearch()
      .then(result => {
        if (!result.abandoned) {
          let newCases = []
         
          this.cases = this.cases.filter(t => (t.type !== "Change Request") && (t.type !== "Service Request"));
       
          this.cases.forEach((rec)=>{
            if (positive == "TPO"){
              if (Utilities.checkTruePositive(rec.caseNumber, rec.status, rec.closureCode)){
                newCases.push(rec)
              } 
            }
            else if (positive == "FPO"){
              if (Utilities.checkFalsePositive(rec.status, rec.closureCode)){
                newCases.push(rec)
              }
            }
          })
           
          this.casesCount = newCases.length;
          this.cases = newCases;
          this.casesLoaded = true
        }
      })
      .catch(err => {
        this.handlerError(err);
      });
  }
  /**
   * Return cases based on priorities
   */
   priorityCases(priority) {
    this.casesLoaded = false;
    this.searched = false;

    this.searchCriteria = new SupportCaseSearchCriteria();
    this.searchCriteria.limit = 12;
    this.searchCriteria.skip = this.perPage * (this.currentPage-1);
    this.searchCriteria.status = constants.itsm.open;
    this.searchCriteria.priority = priority
    if(this.sort && this.sortBy){
      this.searchCriteria.sort = this.sort;
      this.searchCriteria.sortBy = this.sortBy;
    }

    this.caseSearch()
      .then(result => {
        if (!result.abandoned) {
          this.casesLoaded = true
        }
      })
      .catch(err => {
        this.handlerError(err);
      });
  }


  /**
   * Load a saved search and run
   * @param savedSearch 
   */
  loadSearch(savedSearch: SupportCaseSearchCriteria){
    this.searchCriteria = savedSearch;
    this.casesLoaded = false;
    this.caseSearch()
      .then(result => {
        if (!result.abandoned) {
          this.casesLoaded = true
        }
      })
      .catch(err => {
        this.handlerError(err)
      });
  }

  /**
   * Delete a saved search
   * @param event 
   * @param content 
   * @param savedSearch 
   */
  deleteSearch(event, content, savedSearch: SupportCaseSearchCriteria): void {
    event.stopPropagation();
    this.modalService.open(content, { ariaLabelledBy: 'search-modal' }).result
      .then((result) => {
        if(result == 'delete'){
          this.userprefService.userPreferencesUpdateChildArray("searches", "support", savedSearch, true)
            .then(res => {
              this.refreshSupportUserPrefs();
            });
        }
      }, (reason) => {
      });
  }

  /**
   * Error handling forwarder, only not going direct so 
   * it allows us to add context within this module
   * @param err 
   */
  private handlerError(err){
    this.errorService.handlerError(err);
  }
}
export function convertDatesFormat(res: any): Case[] {
   
  let cases:Case[] = [];
  if(res.length == undefined){
    let singleCase = res;
    singleCase = transformDates(singleCase)
    cases.push(singleCase);
  }
  else{
    res.forEach(element => {
      let singleCase = element;
      singleCase = transformDates(singleCase)
      
      cases.push(singleCase);
    });
  
  }
  return cases;
}

function convertToUtcFormat(date: string) {
  // convert "2022-03-24 14:40:03" to "2022-03-24T14:40:03.000+0000"
  if (date.indexOf(" ") > -1) {
    date = date.replace(" ", "T");
    date = date + ".000+0000"; // UTC timezone
  }
  return date;
}

function transformDates(singleCase: any): any {
  singleCase.createdDate = convertToUtcFormat(singleCase.createdDate);

  singleCase.comments.forEach((element, index) => {
    singleCase.comments[index].createdDate = convertToUtcFormat(element.createdDate);
  });

  singleCase.attachments.forEach((element, index) => {
    singleCase.attachments[index].createdDate = convertToUtcFormat(element.createdDate)
  });

  if(singleCase.lastModifiedDate != undefined){
    singleCase.lastModifiedDate = convertToUtcFormat(singleCase.lastModifiedDate);
  }

  return singleCase;
}

